import React from "react";
import {
    SiHtml5,
    SiCss3,
    SiJavascript,
    SiReact,
    SiPhp,
    SiMysql,
    SiWordpress,
    SiBootstrap,
    SiAdobephotoshop,
    SiAdobeillustrator,
    SiAdobexd,
    SiAdobepremierepro,
} from 'react-icons/si';

const TechnoIcon = (props) => {
    const techno = props.techno;

    switch (techno) {
        case "HTML":
            return (
                <span className="icon">
                <SiHtml5/>
                </span>
            );

        case "React":
            return (
                <span className="icon">
                <SiReact />
                </span>
            );

        case "CSS":
            return (
                <span className="icon">
                <SiCss3 />
                </span>
            );

        case "Photoshop":
            return (
                <span className="icon">
                <SiAdobephotoshop/>
                </span>
            );

        case "Illustrator":
            return (
                <span className="icon">
                <SiAdobeillustrator />
              </span>
            );

        case "Adobe XD":
            return (
                <span className="icon">
                <SiAdobexd />
               </span>
            );

        case "JavaScript":
            return (
                <span className="icon">
                <SiJavascript />
               </span>
            );
        case "PHP":
            return (
                <span className="icon">
                <SiPhp />
               </span>
            );

        case "Wordpress":
            return (
                <span className="icon">
                <SiWordpress />
                </span>
            );
        case "Wordpress":
            return (
                <span className="icon">
                <SiBootstrap />
              </span>
            );
        case "Premiere Pro":
            return (
                <span className="icon">
                <SiAdobepremierepro />
            </span>
            );
        case "SQL":
            return (
                <span className="icon">
                <SiMysql />
           </span>
            );
            case "Bootstrap":
            return (
                <span className="icon">
                <SiBootstrap />
           </span>
            );

        default:
            return (
                <p> Pas d'icone à afficher </p>
            );
    };
};

export default TechnoIcon;